/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.CancelScheduledWithdrawResponse,
  CancelScheduledWithdraw: (params: vp.CancelScheduledWithdrawRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCancelScheduledWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCancelScheduledWithdraw, setShouldCancelScheduledWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CancelScheduledWithdrawRequest>({
    ScheduledTransactionID: ''
  });
  const [response, setResponse] = useState<vp.CancelScheduledWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    Status: ''
  });

  useEffect(() => {
    if (!shouldCancelScheduledWithdraw) return () => {};

    const PostCancelScheduledWithdraw = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postCancelScheduledWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCancelScheduledWithdraw) void PostCancelScheduledWithdraw();
    setShouldCancelScheduledWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldCancelScheduledWithdraw]);

  return [
    response,
    (_params: vp.CancelScheduledWithdrawRequest) => {
      setParams(_params);
      setShouldCancelScheduledWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Status: '',
      });
      setShouldCancelScheduledWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCancelScheduledWithdraw);